<template>
  <div class="cover awaiting-payment">
    <div v-if="error"
          class="awaiting-payment__error">
      {{error}}
    </div>

    <pulsate-icon pulsateColor="red"
                 :size="$isMobile ? 'medium' : 'large'">
      <div class="awaiting-payment__timer">
        <p class="countdown">{{ timerDisplay }}</p>
        <p class="timer-title">Time Left</p>
      </div>
    </pulsate-icon>
    <div class="awaiting-payment__text-container">
      <p class="Title1">Complete Your Payment</p>
      <p class="Body1">
        To continue with your booking, please complete your payment of <span class="bold">P {{fee}}</span> by pressing the button below.
      </p>
    </div>
    <smd-btn class="btn004 btn004--red-enabled awaiting-payment__btn"
              @click="payNow">
      Pay Now
    </smd-btn>
    <smd-btn class="btn004 btn004--unselected awaiting-payment__cancel-btn"
              @click="cancelRequest">
      Cancel Request
    </smd-btn>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import PulsateIcon from '@/views/ondemand/components/pulsate-icon.vue';
  import {OnDemandService} from '@/services/ondemand';
  import {
    GETTER_ONDEMAND_BOOKING_DETAILS,
  } from '@/store/types';

  export default {
    name: 'awaiting-payment',
    components: {
      PulsateIcon,
    },
    data() {
      return {
        timerDisplay: null,
        timerReference: null,
        error: null,
      }
    },
    computed: {
      ...mapGetters({
        bookingDetails: GETTER_ONDEMAND_BOOKING_DETAILS,
      }),
      fee() {
        return (this.bookingDetails.subtotal + this.bookingDetails.service_charge).toFixed(2);
      },
    },
    mounted() {
      this.countdownTimer();
    },
    destroyed() {
      clearInterval(this.timerReference);
    },
    methods: {
      countdownTimer() {
        this.timerReference = setInterval(() => {
          const currTime = new Date().getTime();
          const deadlineTime = new Date(this.bookingDetails.approvaldeadline).getTime();
          const difference = deadlineTime - currTime;

          const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((difference % (1000 * 60)) / 1000);

          this.timerDisplay = `${minutes.toString().padStart(2, 0)}:${seconds.toString().padStart(2,0)}`;
        }, 1000);
      },
      payNow() {
        window.location.href = this.bookingDetails.billurl;
      },
      async cancelRequest() {
        this.$emit('set-loading', true);

        try {
          const {data} = await OnDemandService.cancelODBooking(this.bookingDetails._id);

          if (data.result !== 1) throw Error();

          this.handleCancelResult(data);
          this.$emit('set-loading', false);
        } catch (err) {
          console.log(err);
          this.$emit('set-loading', false);
        }
      },
      handleCancelResult({result}) {
        switch(result) {
          case 1:
            //success
            window.location.reload();
            return;

          case -1:
            this.error = 'Booking has already been accepted.';
            return;

          default:
            this.error = 'Something went wrong.';
            return;
        }
      },
    },
  }
</script>

<style lang="scss">
  @import "@/assets/styles/applications.scss";

  .awaiting-payment {
    &__error {
      padding: 4px 8px;
      background-color: rgba(#DA2525, 0.2);
      border: 1px solid #DA2525;
      border-radius: 8px;
    }

    &__timer {
      @extend %layout--flex-center-xy;

      .countdown {
        color: #DA2525;
        font-size: 36px;
        font-family: $D-DIN-Bold;
        line-height: normal;

        @include responsive(mobile) {
          font-size: 24px;
        }
      }

      .timer-title {
        color: #941818;
        font-size: 12px;
        font-family: $D-DIN-Bold;
        text-transform: uppercase;
      }
    }

    &__text-container {
      @extend %layout--flex-col;
      gap: 10px;
      text-align: center;
      max-width: 380px;

      @include responsive(mobile) {
        max-width: 280px;
      }

      .bold {
        font-family: $D-DIN-Bold;
      }
    }

    &__cancel-btn.btn004 {
      margin-top: 64px;
      border-color: color(white);

      @include responsive(mobile) {
        margin-top: unset;
      }
    }
  }
</style>
